<template>
  <Skeleton title avatar :row="12" :loading="Skeletonloading">
    <div class="detail-warp">
      <div class="t-warp" v-if="say_hello">
        <div class="t-warp-title">亲爱的 {{ say_hello.say_title }}：</div>
        <div class="t-warp-txt">{{ say_hello.say_content }}</div>
      </div>
      <div class="list-warp" v-if="list">
        <List
          @load="getData"
          :loading="loading"
          :finished="finished"
          finished-text="～ 已经到底了 ～"
        >
          <div class="list-item" v-for="(value, key) in list" :key="key">
            <div class="l-t-warp" @click="jump(value.city_en, value.hid)">
              <div class="l-l-img">
                <Image lazy-load :src="value.cover" class="l-l-imgw" />
                <div class="l-l-t">{{ value.licence }}</div>
                <div class="year-icon sprite-new-year-straight"></div>
              </div>
              <div class="l-r-content">
                <div
                  class="con-area"
                  v-if="value.unified_city_cn || value.unified_district"
                  >{{ value.unified_city_cn
                  }}{{
                    value.unified_district ? '/' + value.unified_district : ''
                  }}</div
                >
                <div class="con-title">{{ value.name }}</div>
                <div class="con-tags" v-if="value.tags_name.length > 0">
                  <div
                    class="tag-item"
                    v-for="(i, k) in value.tags_name"
                    :key="k"
                    >{{ i }}</div
                  >
                </div>
                <div class="con-price" v-if="value.price_display_info">{{
                  value.price_display_info.price_display
                }}</div>
              </div>
            </div>
            <div class="l-cont-warp">
              <Tabs
                swipe-threshold="3"
                @click="
                  (chooseindex, title) => {
                    taboptions(value.hid, value.city_en, key),
                      housetypeclick(chooseindex, title)
                  }
                "
              >
                <Tab title="匹配楼盘介绍">
                  <div class="cont-item" v-if="value.tip1">
                    <div class="c-i-title">匹配楼盘介绍</div>
                    <div class="c-i-content">
                      <div class="c-i-txt" v-if="value.tip1.opentime">
                        <div class="c-i-l">开盘时间</div
                        ><div class="c-i-r">{{ value.tip1.opentime }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip1.delivertime">
                        <div class="c-i-l">入住时间</div
                        ><div class="c-i-r">{{ value.tip1.delivertime }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip1.licence">
                        <div class="c-i-l">预售证</div
                        ><div class="c-i-r">{{ value.tip1.licence }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip1.archtype">
                        <div class="c-i-l">建筑类别</div
                        ><div class="c-i-r">{{ value.tip1.archtype }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip1.fitment">
                        <div class="c-i-l">装修情况</div
                        ><div class="c-i-r">{{ value.tip1.fitment }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip1.address">
                        <div class="c-i-l">项目地址</div
                        ><div class="c-i-r">{{ value.tip1.address }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip1.saleaddress">
                        <div class="c-i-l">售楼地址</div>
                        <div class="c-i-r">{{ value.tip1.saleaddress }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="cont-item" v-if="value.tip2">
                    <div class="c-i-title">周边设施</div>
                    <div class="c-i-content">
                      <div class="c-i-txt" v-if="value.tip2.nearby_traffic">
                        <div class="c-i-l">交 通</div
                        ><div class="c-i-r">{{
                          value.tip2.nearby_traffic
                        }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip2.nearby_school">
                        <div class="c-i-l">学 校</div
                        ><div class="c-i-r">{{ value.tip2.nearby_school }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip2.nearby_commercial">
                        <div class="c-i-l">综合商场</div
                        ><div class="c-i-r">{{
                          value.tip2.nearby_commercial
                        }}</div>
                      </div>
                      <div class="c-i-txt" v-if="value.tip2.nearby_park">
                        <div class="c-i-l">公 园</div
                        ><div class="c-i-r">{{ value.tip2.nearby_park }}</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="cont-item"
                    v-if="value.tip3 && value.tip3.introduce"
                  >
                    <div class="c-i-title">项目介绍</div>
                    <div
                      class="c-i-txtarea"
                      v-html="value.tip3.introduce"
                    ></div>
                  </div>
                </Tab>
                <Tab title="户型介绍" v-if="value.is_img !== 0">
                  <div class="houstype-warp">
                    <div
                      class="housetype-item"
                      v-for="(hxitem, hxindex) in value.hxData.housetypelist"
                      :key="hxindex"
                    >
                      <div class="h-i-warp">
                        <Image
                          class="h-img"
                          lazy-load
                          :src="hxitem.pic_no_wm_url"
                          @click="ImagePreviewfn(hxitem.pic_no_wm_url)"
                        />
                        <div class="h-tag" v-if="hxitem.hx_sale_state_name">{{
                          hxitem.hx_sale_state_name
                        }}</div>
                      </div>
                      <div class="h-r">
                        <div class="h-r-t">{{ hxitem.house_type_name }}</div>
                        <div class="h-r-m">{{ hxitem.jm_area }}</div>
                        <div class="h-r-tag" v-if="hxitem.tag_list">
                          <div
                            class="h-tag-item"
                            v-for="(hxtval, hxtindex) in hxitem.tag_list"
                            :key="hxtindex"
                            >{{ hxtval }}</div
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="ht-more"
                      @click="
                        gethtlist(
                          value.hxData.parentindex,
                          value.hid,
                          value.city_en
                        )
                      "
                      v-if="
                        value.hxData.count - value.hxData.housetypelist.length >
                        0
                      "
                      >查看更多（{{
                        value.hxData.count - value.hxData.housetypelist.length
                      }}）</div
                    >
                  </div>
                </Tab>

                <Tab title="市场解读" v-if="value.has_market_unscramble">
                  <div class="mark-warp">
                    <Image
                      class="img-top"
                      lazy-load
                      src="https://src.leju.com/imp/imp/deal/a6/a0/7/0369a3cb9f95d1146bb50d0a1c0_p122_mk169.png"
                    />
                    <div
                      v-html="value.markData.marklist"
                      class="cont-warp"
                      :class="value.markData.ismore ? 'zk-more' : ''"
                    ></div>

                    <div class="btn-warp" v-if="value.markData.ismore">
                      <Image
                        src="https://src.leju.com/imp/imp/deal/e6/55/9/174e88a7bd29c3712ed5ebf31ab_p122_mk169.png"
                      />
                      <div class="img-btn" @click="zkmore(key)">
                        <div class="btn-txt">展开</div>
                        <img
                          class="zk-img"
                          src="https://src.leju.com/imp/imp/deal/b6/ed/5/e77255488e2bf59c8f96d47cbe1_p122_mk169.png"
                        />
                      </div>
                    </div>
                    <Image
                      lazy-load
                      class="rotateX"
                      src="https://src.leju.com/imp/imp/deal/a6/a0/7/0369a3cb9f95d1146bb50d0a1c0_p122_mk169.png"
                    />
                  </div>
                </Tab>
                <Tab title="城市资讯" v-if="value.has_new_news">
                  <div class="sc-warp">
                    <div
                      class="sc-item"
                      v-for="(czitem, czindex) in value.cityInfoData
                        .cityinfolist"
                      :key="czindex"
                      @click="jumpurl(czitem.url)"
                    >
                      <Image
                        class="sc-img"
                        lazy-load
                        :src="
                          czitem.photo
                            ? czitem.photo
                            : 'https://src.leju.com/imp/imp/deal/ec/96/e/8cc272995fbf1530c81c8422fa3_p122_mk169.png'
                        "
                      />
                      <div class="sc-cont-warp">
                        <div class="sc-title">{{ czitem.title }}</div>
                        <div class="sc-b">{{ czitem.createtime }}</div>
                      </div>
                    </div>
                    <div
                      class="sc-more"
                      @click="
                        cityInfolist(
                          value.cityInfoData.parentindex,
                          value.hid,
                          value.city_en
                        )
                      "
                      v-if="
                        value.cityInfoData.count -
                          value.cityInfoData.cityinfolist.length >
                        0
                      "
                      >查看更多（{{
                        value.cityInfoData.count -
                        value.cityInfoData.cityinfolist.length
                      }}）</div
                    >
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </List>
      </div>
      <div class="float">
        <img
          class="float-img"
          src="https://src.leju.com/imp/imp/deal/aa/2a/0/8017976655fbce9c402b935dc47_p122_mk169.png"
        />
      </div>
      <div class="flat-warp">
        <div class="float-dialog" @click="dialogfn"> </div>
        <div class="float-back" @click="backhome"> </div>
      </div>
    </div>
    <DiglogForm v-model:show="visibleFormPopup" />
  </Skeleton>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  ref,
  nextTick
} from 'vue'
import { Image, Tab, Tabs, Toast, List, Skeleton, ImagePreview } from 'vant'
import { request } from '@/utils/request'
import { useRoute, LocationQueryValue, useRouter } from 'vue-router'
import qs from 'qs'
import DiglogForm from '@/components/DiglogForm.vue'
import {
  DetailData,
  housetypeData,
  cityInfoData,
  markData
} from '@/api-types.d.ts'
import { Statistical } from './Home.vue'

type Options = Record<string, string | LocationQueryValue[] | null>
interface TabState {
  hxData: {
    housetypelist: housetypeData.Datum[]
    htfinished: boolean
    htloading: boolean
    htpage: number
    parentindex: number
    count: number
  }
  cityInfoData: {
    cityinfolist: cityInfoData.Datum[]
    finished: boolean
    loading: boolean
    page: number
    parentindex: number
    count: number
  }
  markData: {
    marklist: string
    ismore: boolean
  }
}
interface Data {
  say_hello: DetailData.Sayhello | Record<string, never>
  list: Array<DetailData.List & TabState>
  finished: boolean
  loading: boolean
  page: number
  options: Options
}

const statistical = new Statistical()

const getDataVars = (detailData: Data) => {
  const Skeletonloading = ref(true)
  const getData = async () => {
    if (detailData.loading) return
    detailData.loading = true
    try {
      const {
        data: {
          code,
          entry: { data }
        }
      } = await request.get<DetailData.RootObject>(
        '/?site=api&ctl=purchase&act=report&' +
          qs.stringify(detailData.options) +
          '&page=' +
          detailData.page++
      )
      detailData.loading = false
      detailData.finished = (detailData.page - 1) * 3 >= data.count
      if (code == '0') {
        detailData.say_hello = data.say_hello
        detailData.list.push(
          ...data.list.map(item =>
            Object.assign<DetailData.List, TabState>(item, {
              hxData: {
                housetypelist: [],
                htpage: 1,
                htloading: false,
                htfinished: true,
                parentindex: 0,
                count: 0
              },
              cityInfoData: {
                cityinfolist: [],
                page: 1,
                loading: false,
                finished: true,
                parentindex: 0,
                count: 0
              },
              markData: {
                marklist: '',
                ismore: false
              }
            })
          )
        )
        Skeletonloading.value = false
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      detailData.loading = false
      Toast.fail('获取数据失败')
    }
  }

  const router = useRouter()
  const visibleFormPopup = ref(false)
  const backhome = () => {
    router.push({ path: '/' })
  }
  const dialogfn = () => {
    visibleFormPopup.value = true
  }
  const route = useRoute()
  onMounted(() => {
    if (route.query.city_en) {
      detailData.options = route.query
      getData()
    } else {
      backhome()
    }
  })

  return {
    dialogfn,
    visibleFormPopup,
    backhome,
    getData,
    Skeletonloading,
    ...toRefs(detailData)
  }
}

const gethtData = (detailData: Data) => {
  const choosetype = reactive({
    hid: '',
    city: '',
    parentindex: 0
  })
  const taboptions = (hid: string, city: string, key: number) => {
    choosetype.hid = hid
    choosetype.city = city
    choosetype.parentindex = key
  }
  const housetypeclick = (value?: number, title?: string) => {
    const list = detailData.list[choosetype.parentindex]
    if (title === '户型介绍' && list.hxData.housetypelist.length < 1) {
      gethtlist(choosetype.parentindex, choosetype.hid, choosetype.city)
    } else if (title === '市场解读' && list.markData.marklist === '') {
      marklist(choosetype.parentindex, choosetype.hid, choosetype.city)
    } else if (
      title === '城市资讯' &&
      list.cityInfoData.cityinfolist.length < 1
    ) {
      cityInfolist(choosetype.parentindex, choosetype.hid, choosetype.city)
    }
  }
  //户型图接口
  const gethtlist = async (value: number, hid: string, city_en: string) => {
    const { hxData: htData } = detailData.list[value]
    try {
      const {
        data: {
          code,
          entry: { data, count }
        }
      } = await request.get<housetypeData.RootObject>(
        '/?site=api&ctl=purchase&act=house_img&city_en=' +
          city_en +
          '&hid=' +
          hid +
          '&page=' +
          htData.htpage++
      )
      htData.parentindex = value
      htData.htfinished = (htData.htpage - 1) * 5 >= count
      htData.htloading = false
      if (code == '0') {
        htData.count = count
        htData.housetypelist.push(...data)
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      htData.htloading = false
      Toast.fail('获取数据失败')
    }
  }
  //城市资讯接口
  const cityInfolist = async (value: number, hid: string, city_en: string) => {
    const { cityInfoData: cityInfoData } = detailData.list[value]
    try {
      const {
        data: {
          code,
          entry: { data, count }
        }
      } = await request.get<cityInfoData.RootObject>(
        '/?site=api&ctl=purchase&act=get_new_news&city_en=' +
          city_en +
          '&hid=' +
          hid +
          '&page=' +
          cityInfoData.page++
      )
      cityInfoData.parentindex = value
      cityInfoData.finished = (cityInfoData.page - 1) * 5 >= count
      cityInfoData.loading = false
      if (code == '0') {
        cityInfoData.count = count
        cityInfoData.cityinfolist.push(...data)
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      cityInfoData.loading = false
      Toast.fail('获取数据失败')
    }
  }
  //市场解读
  const marklist = async (value: number, hid: string, city_en: string) => {
    const { markData: markData } = detailData.list[value]
    try {
      const {
        data: {
          code,
          entry: { data }
        }
      } = await request.get<markData.RootObject>(
        '/?site=api&ctl=purchase&act=get_market_unscramble&city_en=' +
          city_en +
          '&hid=' +
          hid
      )
      if (code == '0') {
        markData.marklist = data
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      Toast.fail('获取数据失败')
    }
    nextTick(() => {
      if (document.getElementsByClassName('cont-warp')[0].clientHeight > 600) {
        markData.ismore = true
      }
    })
  }
  const zkmore = (value: number) => {
    const { markData: markData } = detailData.list[value]
    markData.ismore = !markData.ismore
  }
  return {
    zkmore,
    taboptions,
    housetypeclick,
    gethtlist,
    cityInfolist,
    marklist
  }
}
export default defineComponent({
  name: 'Detail',
  components: {
    DiglogForm,
    Image,
    Tab,
    Tabs,
    List,
    Skeleton
  },
  setup() {
    const route = useRoute()
    onMounted(() => {
      window.city = (route.query.city_en as string) || ''
      window.news_source = 'detail'
      statistical.perform()
    })

    const detailData = reactive<Data>({
      say_hello: {},
      list: [],
      finished: true,
      loading: false,
      page: 1,
      options: {}
    })
    const jump = (city?: string, hid?: string) => {
      window.location.href = `//m.leju.com/touch/house/${city}/${hid}?oc_source=m_zhuanti_fanxiang`
    }
    const jumpurl = (url: string) => {
      window.location.href = url
    }
    const ImagePreviewfn = (img: string) => {
      ImagePreview({
        images: [img]
      })
    }
    return {
      ImagePreviewfn,
      jump,
      jumpurl,
      ...getDataVars(detailData),
      ...gethtData(detailData)
    }
  }
})
</script>

<style lang="scss" scoped>
.float {
  position: fixed;
  bottom: 15vh;
  right: 0;
  z-index: 100;
  .float-img {
    width: 57px;
    height: 105px;
  }
}

.flat-warp {
  position: fixed;
  bottom: 15vh;
  right: 0;
  z-index: 101;
  .float-back {
    width: 57px;
    height: 52.5px;
  }
  .float-dialog {
    width: 57px;
    height: 52.5px;
  }
}

.detail-warp {
  padding: 20px 0;
  .t-warp {
    padding: 4px 20px 0;
    .t-warp-title {
      font-size: 20px;
      font-weight: 500;
      color: #4a4a4a;
      line-height: 28px;
    }
    .t-warp-txt {
      padding-top: 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4a4a4a;
      line-height: 25px;
    }
  }
  .list-warp {
    .list-item {
      border-bottom: 1px solid #ebebeb;
      padding-top: 32px;
      &:last-child {
        border-bottom: none;
      }
      .l-t-warp {
        margin: 0 20px;
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, #ff4040 0%, #dc2f37 100%);
        border-radius: 10px;
        border: 3px solid #efb258;
        padding: 12px;
        .l-l-img {
          position: relative;
          width: 132px;
          height: 99px;
          overflow: hidden;
          border-radius: 4px;
          .l-l-imgw {
            width: 100%;
            height: 100%;
            :deep .van-image__img {
              border-radius: 4px;
            }
          }
          .year-icon {
            position: absolute;
            right: -1px;
            bottom: -1px;
          }
          .l-l-t {
            position: absolute;
            max-width: 107px;
            top: 8px;
            left: 10px;
            padding: 0 7px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 8px;
            opacity: 0.8;
            font-size: 8px;
            font-weight: 400;
            color: #ffffff;
            line-height: 14px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
          }
        }
        .l-r-content {
          margin-left: 12px;
          .con-area {
            width: 171px;
            height: 15px;
            font-size: 11px;
            font-weight: 600;
            color: #fbbd79;
            line-height: 15px;
            margin-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .con-title {
            width: 171px;
            height: 23px;
            font-size: 16px;
            font-weight: 500;
            color: #feebb1;
            line-height: 23px;
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .con-tags {
            display: flex;
            margin-bottom: 8px;
            .tag-item {
              width: 54px;
              height: 20px;
              padding: 0 4px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              background: #f9c37d;
              border-radius: 4px;
              font-size: 12px;
              font-weight: 400;
              color: #d30019;
              line-height: 20px;
              margin-right: 4px;
              text-align: center;
              vertical-align: middle;
              &:last-child {
                margin-right: 0;
              }
            }
          }
          .con-price {
            width: 171px;
            height: 20px;
            font-size: 14px;
            font-weight: 600;
            color: #feebb1;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .l-cont-warp {
        padding: 30px 0;
        :deep .van-tabs__content {
          padding: 0 20px;
        }
        :deep .van-tabs__wrap {
          overflow: hidden;
        }
        :deep .van-tabs--line .van-tabs__wrap {
          height: auto;
        }
        :deep .van-tabs__nav--complete {
          padding-left: 0;
        }
        :deep .van-tabs__nav {
          display: block;
          white-space: nowrap;
        }
        :deep .van-tabs__nav--line {
          padding-bottom: 0;
        }
        :deep .van-tabs__line {
          display: none;
        }
        :deep .van-tabs__nav {
          &:last-child {
            margin-right: 5px;
            margin-left: 0;
          }
        }
        :deep .van-tab {
          display: inline-block;
          text-align: center;
          width: 96px;
          margin-right: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #9b9b9b;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
          border: 1px solid #eaeaea;
          &:first-child {
            margin-left: 20px;
          }
        }
        :deep .van-tab--active {
          width: 96px;
          font-size: 12px;
          font-weight: 600;
          line-height: 32px;
          background: linear-gradient(180deg, #ff4040 0%, #dc2f37 100%);
          border-radius: 4px;
          border: 1px solid #fdd397;
          color: #feebb1;
        }
        :deep .van-tabs__wrap--scrollable .van-tab {
          padding: 0;
        }
        .cont-item {
          padding: 32px 0 16px;
          &:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }
          border-bottom: 1px solid #ebebeb;
          .c-i-title {
            height: 28px;
            font-size: 20px;
            font-weight: 500;
            color: #4a4a4a;
            line-height: 28px;
            margin-bottom: 16px;
          }
          .c-i-content {
            .c-i-txt {
              display: flex;
              padding-bottom: 8px;
              .c-i-l {
                min-width: 56px;
                font-size: 14px;
                font-weight: 400;
                color: #9b9b9b;
                line-height: 20px;
                margin-right: 12px;
              }
              .c-i-r {
                font-size: 14px;
                font-weight: 600;
                color: #4a4a4a;
                line-height: 20px;
              }
            }
          }
          .c-i-txtarea {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4a4a4a;
            line-height: 25px;
          }
        }
        .houstype-warp {
          padding-top: 32px;
          .housetype-item {
            &:last-child {
              padding-bottom: 0;
            }
            display: flex;
            padding-bottom: 16px;
            .h-i-warp {
              position: relative;
              width: 75px;
              height: 75px;
              border-radius: 8px;
              overflow: hidden;
              .h-img {
                width: 100%;
                height: 100%;
                border: 1px solid #f0f0f0;
                :deep .van-image__img {
                  border-radius: 8px;
                }
              }
              .h-tag {
                position: absolute;
                top: 0;
                left: 0;
                padding: 0 6px;
                max-width: 70px;
                height: 16px;
                background: linear-gradient(180deg, #ff4040 0%, #dc2f37 100%);
                border-radius: 8px 0px 8px 0px;
                font-size: 10px;
                font-weight: 500;
                color: #ffffff;
                line-height: 16px;
                text-align: center;
                vertical-align: middle;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .h-r {
              margin-left: 16px;
              .h-r-t {
                width: 207px;
                height: 23px;
                font-size: 16px;
                font-weight: 500;
                color: #000000;
                line-height: 23px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .h-r-m {
                width: 207px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: #4a4a4a;
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .h-r-tag {
                display: flex;
                padding-top: 18px;
                .h-tag-item {
                  padding: 0 4px;
                  height: 17px;
                  background: #edf7fd;
                  border-radius: 2px;
                  font-size: 12px;
                  font-weight: 500;
                  color: #3c81ac;
                  line-height: 17px;
                  text-align: center;
                  vertical-align: middle;
                }
              }
            }
          }
          .ht-more {
            padding-top: 8px;
            height: 17px;
            font-size: 12px;
            font-weight: 600;
            color: #3c81ac;
            line-height: 17px;
          }
        }
        .sc-warp {
          padding-top: 32px;
          .sc-item {
            padding-bottom: 24px;
            &:last-child {
              padding-bottom: 0;
            }
            display: flex;
            .sc-img {
              width: 156px;
              height: 117px;
              :deep .van-image__img {
                border-radius: 8px;
              }
            }
            .sc-cont-warp {
              padding: 8px 0 8px 16px;
              .sc-title {
                width: 155px;
                font-size: 16px;
                font-weight: 500;
                color: #000000;
                line-height: 22px;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-clamp: 2;
              }
              .sc-b {
                padding-bottom: 32px;
                width: 155px;
                height: 20px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #4a4a4a;
                line-height: 20px;
              }
            }
          }
          .sc-more {
            padding-top: 8px;
            height: 17px;
            font-size: 12px;
            font-weight: 600;
            color: #3c81ac;
            line-height: 17px;
          }
        }
        .mark-warp {
          padding-top: 32px;
          .img-top {
            width: 340px;
            height: 70px;
            position: absolute;
          }
          .btn-warp {
            position: absolute;
            bottom: 20px;

            .img-btn {
              z-index: 22;
              position: absolute;
              display: flex;
              align-items: center;
              bottom: 30px;
              left: 50%;
              margin-left: -20px;
              .btn-txt {
                width: 24px;
                height: 17px;
                font-size: 12px;
                font-weight: 600;
                color: #3c81ac;
                margin-right: 4px;
                line-height: 17px;
              }
              .zk-img {
                width: 12px;
                height: 12px;
              }
            }
          }
          .cont-warp {
            padding: 50px 30px 0 30px;
          }
          .zk-more {
            max-height: 600px;
            overflow: hidden;
          }
          :deep .rotateX {
            width: 340px;
            height: 70px;
            z-index: 20;
            transform: rotateX(180deg);
            -webkit-transform: rotateX(180deg);
          }
        }
      }
    }
  }
}
</style>
